import React, { FC, useEffect, useState } from 'react'
import Modal from './Modal'
import { SettingHolidayMember } from '../../../states/types/setting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MonthlyCalendar from '../setting/holidaySchedule/MonthlyCalendar'
import { format } from '../../../utils/date'
import { Link } from 'react-router-dom'
import { setPath } from '../../../utils/url'
import { URL } from '../../constants/url'
import LoadingSquare from './LoadingSquare'

interface SubmitParam {
  memberIds: number[]
  holidays: string[]
  useCommonSetting: boolean
  isHoliday: boolean
}

interface Props {
  targetMemberList: SettingHolidayMember[]
  isDisplayModal: boolean
  submitCallback: (data: SubmitParam) => void
  closeCallback: VoidFunction
  targetYear: number
  memberHolidays: string[]
}

const DISPLAY_MODAL_MEMBER_LIMIT = 30

const SettingBaseWorkTimeModal: FC<Props> = (props) => {
  const {
    targetMemberList,
    isDisplayModal,
    submitCallback,
    closeCallback,
    targetYear,
    memberHolidays,
  } = props

  const [isHoliday, setIsHoliday] = useState<boolean>(true)
  const [holidayList, setHolidayList] = useState<string[][]>([])
  const [tmpHolidays, setTmpHolidays] = useState<string[][]>([])
  const [isSubmit, setIsSubmit] = useState<boolean>(false)
  const [isClear, setIsClear] = useState<boolean>(false)
  const [quickChange, setQuickChange] = useState<string>("")
  const [isUseCommonHolidayList, setIsUseCommonHolidayList] = useState<boolean>(false)
  const [isDetailLoading, setIsDetailLoading] = useState<boolean>(false)

  const changeSettingHoliday = () => {
    setIsHoliday((v) => !v)
  }

  const changeHoliday = (holidays: string[]) => {
    setTmpHolidays((cur) => [...cur, holidays])
  }

  const clickQuickHolidaySetting = (type: string) => {
    setQuickChange(type)
  }

  const clearNotWorkdayList = () => {
    setIsClear(true)
  }

  const buildQuickHolidaySettingBox = () => (
    <div
      style={{
        border: "solid 1px #CCCCCC",
        borderRadius: "4px",
        marginBottom: "16px",
        backgroundColor: "#FFFFFF",
        padding: "8px",
      }}
    >
      <div
        style={{
          marginBottom: "8px",
        }}
      >
        クイック選択
      </div>
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "8px",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("sss")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#fff1f1",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              backgroundImage: "linear-gradient(135deg, rgb(255 241 241), rgb(255 241 241) 20%, rgb(230, 245, 255))",
            }}
          >
            {`${targetYear}年の土日祝`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("sun")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#fff1f1",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の日曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("mon")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の月曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("tue")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の火曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("wed")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の水曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("thu")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の木曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("fri")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の金曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("sat")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#e6f5ff",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の土曜日`}
          </button>
          <button
            type="button"
            onClick={() => clickQuickHolidaySetting("holiday")}
            style={{
              border: "solid 1px #CCCCCC",
              borderRadius: "4px",
              backgroundColor: "#fff1f1",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {`${targetYear}年の祝日`}
          </button>
        </div>
      </div>
    </div>
  )

  const buildCheckBox = (value: boolean) => (
    value ? (
      <FontAwesomeIcon
        icon={["fas", "check-square"]}
        style={{ color: "#008800" }}
        fixedWidth
      />
    ) : (
      <FontAwesomeIcon
        icon={["far", "square"]}
        style={{ color: "#999999" }}
        fixedWidth
      />
    )
  )

  const changeUseCommon = (callback: (v: React.SetStateAction<boolean>) => void) => {
    callback((v) => !v)
  }

  const close = () => {
    closeCallback()
    setTmpHolidays([])
  }

  const submit = () => {
    if (isHoliday) {
      setIsSubmit(true)
    } else {
      const param: SubmitParam = {
        memberIds: targetMemberList.map((v) => v.id),
        holidays: [],
        useCommonSetting: isUseCommonHolidayList,
        isHoliday: isHoliday,
      }
      submitCallback(param)
      close()
      setTmpHolidays([])
    }
  }

  useEffect(() => {
    setIsDetailLoading(true)
    const tmp = Array(12).fill(null).map((_v, i) => (
      memberHolidays.filter((w) => Number(format(w, "M")) === i + 1)
    ))
    setHolidayList(tmp)
    setTimeout(() => {
      setIsDetailLoading(false)
    }, 1000)
  }, [memberHolidays])

  useEffect(() => {
    if (tmpHolidays.length !== 12 || !isSubmit) return
    const param: SubmitParam = {
      memberIds: targetMemberList.map((v) => v.id),
      holidays: tmpHolidays.flat(),
      useCommonSetting: isUseCommonHolidayList,
      isHoliday: isHoliday,
    }
    submitCallback(param)
    close()
    setIsSubmit(false)
    setTmpHolidays([])
  }, [tmpHolidays, isSubmit])

  useEffect(() => {
    if (!targetMemberList.length) return
    setIsHoliday(targetMemberList[0].enabled ?? true)
    setIsUseCommonHolidayList(targetMemberList[0].use_common_setting)
  }, [targetMemberList])

  return (
    <Modal
      show={isDisplayModal}
      wrapperClass="w1100"
      closeCallback={close}
      closeable
    >
      <>
        <div
          style={{
            textAlign: "center",
            fontSize: "20px",
            marginBottom: "16px",
          }}
        >
          休日設定
        </div>
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            gap: "16px",
          }}
        >
          <div
            style={{
              border: "solid 1px #999999",
              borderRadius: "4px",
              padding: "8px",
              display: "flex",
              flexFlow: "column",
              gap: "8px",
              backgroundColor: "#F3F3f3",
            }}
          >
            <div>
              対象
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
              }}
            >
              {
                targetMemberList.slice(0, DISPLAY_MODAL_MEMBER_LIMIT).map((v) => (
                  <div
                    key={`member_${v.id}`}
                    style={{
                      border: "solid 1px #999999",
                      borderRadius: "20px",
                      padding: "2px 8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      fontSize: "10px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <img
                      alt={v.name}
                      src={v.profile_image ?? `/static/images/profile/${(Number(v.id) || 0) % 12}.jpeg`}
                      style={{ width: "16px", height: "16px", borderRadius: "50%" }}
                    />
                    {v.name}
                  </div>
                ))
              }
              {
                targetMemberList.length > DISPLAY_MODAL_MEMBER_LIMIT && (
                  <div
                    style={{
                      padding: "3px",
                    }}
                  >
                    {`…他${targetMemberList.length - DISPLAY_MODAL_MEMBER_LIMIT}名`}
                  </div>
                )
              }
            </div>
          </div>
          <div
            style={{
              border: "solid 1px #999999",
              borderRadius: "4px",
              padding: "8px",
              display: "flex",
              flexFlow: "column",
              gap: "8px",
            }}
          >
            <div>
              休日設定
            </div>
            <div
              style={{
                display: "flex",
                flexFlow: "column",
                gap: "8px",
              }}
            >
              <div
                style={{
                  position: "relative",
                  border: "solid 1px #CCCCCC",
                  borderRadius: "4px",
                  backgroundColor: "#fffafa",
                  padding: "16px",
                  display: "flex",
                  flexFlow: "column",
                  gap: "8px",
                }}
              >
                {
                  isUseCommonHolidayList && (
                    <div
                      style={{
                        position: "absolute",
                        top: "28px",
                        left: 0,
                        width: "100%",
                        height: "calc(100% - 28px)",
                        backgroundColor: "rgba(243, 243, 243, 0.8)",
                        zIndex: "2000",
                      }}
                    />
                  )
                }
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: "#f3f3f3",
                    padding: "8px",
                    margin: "-16px -16px 0 -16px",
                    borderRadius: "4px 4px 0 0",
                    marginBottom: "8px",
                  }}
                >
                  <div>
                    休日設定
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                      cursor: "pointer",
                      fontSize: "10px",
                      color: "#666666",
                    }}
                    onClick={() => changeUseCommon(setIsUseCommonHolidayList)}
                    role="none"
                  >
                    {buildCheckBox(isUseCommonHolidayList)}
                    全体設定に準拠する
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      userSelect: "none",
                      cursor: "pointer",
                    }}
                    onClick={changeSettingHoliday}
                    role="none"
                  >
                    {buildCheckBox(isHoliday)}
                    休日を設定する
                  </div>
                </div>
                {
                  isHoliday && (
                    <>
                      <div
                        style={{
                          border: "solid 1px #FF0000",
                          borderRadius: "4px",
                          padding: "8px",
                          color: "#FF0000",
                          backgroundColor: "#ffeeee",
                        }}
                      >
                        ※ 休日設定は計測時間を制限するものではありません。計測時間の設定は
                        <Link
                          to={setPath(URL.SETTING_MEASUREMENT.path, "ja")}
                          className=""
                        >
                          こちら
                        </Link>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexFlow: "column",
                          gap: "8px",
                        }}
                      >
                        {
                          isDetailLoading && (
                            <div
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                zIndex: "2000",
                              }}
                            >
                              <LoadingSquare>
                                <>
                                  しばらくお待ちください
                                </>
                              </LoadingSquare>
                            </div>
                          )
                        }
                        {buildQuickHolidaySettingBox()}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "16px",
                            position: "relative",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "-10px",
                              left: 0,
                              borderRadius: "4px",
                              backgroundColor: "#fffafa",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "10px",
                              padding: "8px",
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: "#FF0000",
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                opacity: "0.2",
                              }}
                            />
                            ：休日
                          </div>
                          <div>
                            {`${targetYear}年`}
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "-10px",
                              right: 0,
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <button
                              type="button"
                              onClick={clearNotWorkdayList}
                              style={{
                                border: "solid 1px #CCCCCC",
                                borderRadius: "4px",
                                backgroundColor: "#FFFFFF",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                fontSize: "12px",
                              }}
                            >
                              <FontAwesomeIcon icon={['fas', 'ban']} />
                              {`${targetYear}年の休日をすべて解除`}
                            </button>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                            zIndex: "1999",
                          }}
                        >
                          {
                            Array(12).fill(null).map((_v, i) => (
                              <React.Fragment key={`${targetYear}_${i + 1}`}>
                                <MonthlyCalendar
                                  targetYear={targetYear}
                                  targetMonth={i + 1}
                                  holidayList={holidayList[i]}
                                  submitCallback={(value) => changeHoliday(value)}
                                  isSubmit={isSubmit}
                                  isClear={isClear}
                                  quickChange={quickChange}
                                />
                              </React.Fragment>
                            ))
                          }
                        </div>
                      </div>
                    </>
                  )
                }
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
              marginTop: "32px",
            }}
          >
            <button
              type="button"
              style={{
                border: `solid 1px #999999`,
                borderRadius: "4px",
                backgroundColor: "#EEEEEE",
                color: "#666666",
                minWidth: "130px",
                textAlign: "center",
              }}
              onClick={close}
            >
              キャンセル
            </button>
            <button
              type="button"
              style={{
                border: `solid 1px #507DC0`,
                borderRadius: "4px",
                backgroundColor: "#507DC0",
                color: "#FFFFFF",
                minWidth: "130px",
                textAlign: "center",
              }}
              onClick={submit}
            >
              設定する
            </button>
          </div>
        </div>
      </>
    </Modal>
  )
}

export default SettingBaseWorkTimeModal
